import React from "react";
import { connect, useDispatch } from 'react-redux';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useLocation } from "react-router-dom";
import { TextField } from '@material-ui/core';
// handleTheme, handleText,
import {  handleDisplay } from 'pages/redux/actions';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardHeader, CardFooter, CardBody, Container, Row, Col, Form, FormGroup, Input, } from "reactstrap";
import UserHeader from "components/Headers/UserHeader.js";
// import firebase from './../../firebase'
// import axios from 'axios'

const getMuiTheme = () =>
    createMuiTheme({
        overrides: {
            MuiTextField: {
                root: {
                    backgroundColor: '#fff',
                    width: '100%',
                    borderRadius: '5px',
                    border: '0px',
                    '&:hover': {
                        outline: '0',
                    },
                    '& label.Mui-focused': {
                        color: '#7c8892',
                    },
                    '& .MuiInput-underline:after': {
                        borderBottomColor: '#7c8892',
                    },
                    '& .MuiOutlinedInput-root': {
                        height: '45px',
                        '& fieldset': {
                            borderColor: '#e8ecef',
                            borderRadius: '5px',
                            border: '1px',
                            paddingTop: '0px',
                            boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)',
                        },
                        '&:hover fieldset': {
                            borderColor: '#Dbe0e5',
                            border: '1px',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#',
                            border: '1px',
                            boxShadow: '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: 14,
                    },
                    '& .MuiInputLabel-shrink': {
                        marginTop: '-7px',
                        marginLeft: '-13px',
                        fontSize: 16,
                        color: 'black'
                    },
                    '& .MuiFormLabel-root': {
                        color: '#a6afb7',
                        lineHeight: 0.5,
                    }
                }
            }
        },
    });

const useStyles2 = makeStyles((theme) => ({
    dark: {
        fontSize: 15,
        color: '#E6e4eb',
        marginTop: '1px',
        padding: '13px 12px'
    },
    white: {
        fontSize: 15,
        marginTop: '1px',
        padding: '13px 12px'
    },
}));

const Index = (props) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const classes2 = useStyles2();
    // console.log(props.theme)
    const [sendingdata, setSendingdata] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [tt, settt] = React.useState('');
    if (location) {
        // console.log('yes location')
        // console.log(location);
        // console.log(location.state);
        if (location.state != null) {
            if (location.state.token) {
                if (location.state.token === 1) {
                    // console.log(location.state.message);
                    setSendingdata(location.state.message)
                    settt(location.state.type);
                    setOpen(true);
                    location.state.token -= 1;
                }
            }
        }

    }
    else {
        // console.log('nope')
    }
    document.title = 'Settings • Depact'
    // console.log(window.zoom)
    // console.log(document.body.style.zoom )
    // console.log(document.zoom)
    if (props.display === 'xsmall') {
        document.body.style.zoom = 0.7
    }
    else if (props.display === 'small') {
        document.body.style.zoom = 0.85
    }
    else if (props.display === 'xlarge') {
        document.body.style.zoom = 1.3
    }
    else if (props.display === 'large') {
        document.body.style.zoom = 1.15
    }
    else {
        document.body.style.zoom = 1
    }

    // const handleChange = (event) => {
    //     // console.log('yes')
    //     // console.log(event.target.value)
    //     if (event.target.value === 'dark') {
    //         dispatch(handleText('white'))
    //         dispatch(handleTheme('dark'))
    //     }
    //     else if(event.target.value==='white'){
    //         dispatch(handleText('darkp'))
    //         dispatch(handleTheme('white'))
    //     }
    //     else if (event.target.value === 'darkpurple') {
    //         dispatch(handleText('white'))
    //         dispatch(handleTheme('darkpurple'))
    //     }
    //     else{
    //         // console.log('no')
    //     }
    // };

    const handleChangeDisplay = (event) => {
        // console.log('yes')
        // console.log(event.target.value)
        // window.innerWidth -= 100
        if (event.target.value === 'xsmall') {
            dispatch(handleDisplay(event.target.value))
            document.body.style.zoom = 0.7
        }
        else if (event.target.value === 'small') {
            dispatch(handleDisplay(event.target.value))
            document.body.style.zoom = 0.85
        }
        else if (event.target.value === 'xlarge') {
            dispatch(handleDisplay(event.target.value))
            document.body.style.zoom = 1.3
        }
        else if (event.target.value === 'large') {
            dispatch(handleDisplay(event.target.value))
            document.body.style.zoom = 1.15
        }
        else {
            dispatch(handleDisplay(event.target.value))
            document.body.style.zoom = 1
        }
    };

    
    // const msg = firebase.messaging();

    // const handlePush = (event) => {
    //     msg.requestPermission()
    //         .catch((error) => {
    //             console.log(error)
    //             setSendingdata('Something went wrong')
    //             settt('error')
    //             setOpen(true)
    //             return 0;
    //         }).then(() => {
    //             // console.log(msg)
    //             console.log(Notification.permission)
    //             return msg.getToken();
    //         })
    //         .then((data) => {
    //             setSendingdata('Please wait a second')
    //             settt('info')
    //             setOpen(true)
    //             console.log('Token ', data)
    //             var inp = { token: data }
    //             axios.post(process.env.REACT_APP_DOMAIN + '/register-push', inp, { 'headers': { 'Authorization': 'Token ' + props.token } })
    //                 .then((response) => {
    //                     setSendingdata('You will be getting notifications from now on')
    //                     settt('success')
    //                     setOpen(true)
    //                 })
    //                 .catch((error) => {
    //                     console.log(error)
    //                     setOpen(true)
    //                     setSendingdata('Something went wrong')
    //                     settt('error')
    //                 })
    //         })
    // };





    const handleClose = (event, reason) => {
        setOpen(false);
    };
    // const firebaseApp = firebase.apps[0];
    return (
        <>
            <UserHeader id={props.username} />
            {/* <div className="header bg-gradient-bluev pb-7 pt-1 pt-md-7 back">
                <Container fluid>
                    <div className="header-body">
                        <Row>
                        </Row>
                    </div>
                </Container>
            </div> */}
            <Container className="mt--6" fluid>
                <Row>
                    <Col className="order-xl-1" xl="12">
                        <Card className={"shadow cardbg-" + props.theme}>
                            <CardHeader className={"border-0 cardbg-" + props.theme}>
                                <Row className="align-items-center">
                                    <Col xs="8">
                                        <h3 className={"mb-0 textb-" + props.theme}>App Settings</h3>
                                    </Col>
                                    {/* <Col className="text-right" xs="4">
                                        {!edit &&
                                            <Button
                                                color="primary"
                                                onClick={(e) => setedit(!edit)}
                                                size="sm"
                                            >
                                                Edit
                                        </Button>
                                        }
                                        {edit &&
                                            <Button
                                                color="primary"
                                                onClick={(e) => setedit(!edit)}
                                                size="sm"
                                            >
                                                Cancel
                                        </Button>
                                        }
                                    </Col> */}
                                </Row>
                            </CardHeader>
                            {/* <code>
                                <pre>{JSON.stringify(firebaseApp.options, null, 2)}</pre>
                            </code> */}
                            <CardBody className="pb-0" style={{maxHeight: '645px',minHeight: '645px'}}>
                                <Form>


                                    <h6 className="heading-small text-muted mb-2">Display Name</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField variant="outlined" className={"inputbg-" + props.theme} value={props.fullname} name="name" autoComplete="off"
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>


                                    {/*<h6 className="heading-small text-muted mb-2">Theme and Appearance</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup className="mb-4">
                                                     <label>Theme</label> 
                                                        <Input className={"form-control-alternative inputbg-" + props.theme} placeholder="Search Events" type="select" value={props.theme} onChange={handleChange}>
                                                            <option value="white">White</option>
                                                            <option value="dark">Dark (Incomplete)</option>
                                                            <option value="darkpurple">Dark Purple (Incomplete)</option>
                                                        </Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>*/}

                                    <h6 className="heading-small text-muted mb-2">Display</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup className="mb-0">
                                                    {/* <label>Theme</label> */}
                                                    <Input className={"form-control-alternative inputbg-" + props.theme} placeholder="Search Events" type="select" value={props.display} onChange={handleChangeDisplay}>
                                                        <option value="xlarge">Extra Large</option>
                                                        <option value="large">Large</option>
                                                        <option value="medium">Medium</option>
                                                        <option value="small">Small</option>
                                                        <option value="xsmall">Extra Small</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>



                                    <h6 className="heading-small text-muted mb-2">Push Notifications</h6>


                                    {/* <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup className="mb-0">
                                                    <label>Theme</label> 
                                                    <Input className={"form-control-alternative inputbg-" + props.theme} placeholder="Click to turn on notifications" type="button" value="Click to turn on notifications" onClick={handlePush} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>*/}



                                </Form>
                            </CardBody>
                            <CardFooter className={"cardbg-" + props.theme}>
                                {/* <div className="text-center">
                                    <Button
                                        color="info"
                                        outline
                                        disabled={dcontent}
                                        onClick={handleChangeEdit}
                                    >
                                        {editcontent}
                                    </Button>
                                </div> */}
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        display: state.display,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Index);

